module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/classic_0-78581dcbd5cc0a7bb0ac5a047dd70a97.png";